import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { fetchUserProfileDetails } from "modules/Profile/api";
import { IUserDetails } from "modules/Profile/types";
import { 
  setUserProfileLoading, 
  setUserProfileSuccess, 
  setUserProfileError 
} from "store/features/userProfileSlice";
import { LSKeys, getFromLocalStorage } from "utils/ls.utils";

export const useUserProfileSync = () => {
  const dispatch = useDispatch();
  const isV2Auth = getFromLocalStorage(LSKeys.ACCESS_TOKEN);
  
  const {
    data: userDetails,
    isLoading,
    isError,
    error,
  } = useQuery<IUserDetails>({
    queryFn: fetchUserProfileDetails.queryFn,
    queryKey: fetchUserProfileDetails.queryKey,
    enabled: Boolean(isV2Auth),
  });

  // Sync loading state with Redux store
  useEffect(() => {
    if (isLoading) {
      dispatch(setUserProfileLoading());
    }
  }, [isLoading, dispatch]);

  // Sync success data with Redux store
  useEffect(() => {
    if (userDetails) {
      dispatch(setUserProfileSuccess(userDetails));
    }
  }, [userDetails, dispatch]);

  // Sync error state with Redux store
  useEffect(() => {
    if (isError) {
      dispatch(setUserProfileError(error?.message || "Failed to fetch user profile"));
    }
  }, [isError, error, dispatch]);

  return { userDetails, isLoading, isError };
}; 